module.exports = __webpack_public_path__ + "static/media/unnamed (8).dc9d4921.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/items/new/unnamed (8).jpg
// module id = 204
// module chunks = 0